import Save from "./operation-panel-button/save.jsx";
import AccountNav from "../../components/account-nav/account-nav";
import styles from "./panel.css";
import React, { Component } from 'react'

console.log(styles);

class Community extends Component {
  render() {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        paddingRight: '20px'
      }} className={styles.panel}>
        <Save />
        <AccountNav/>
      </div>   
    )
  }
}

export default Community